























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User, Info, Device } from '@/types/core';
import { Probe, ProbeReading } from '@/types/nfresh';
import moment from 'moment';

import tippy from 'tippy.js';


@Component({
  components:{
  }
})
export default class NfreshReadingRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) probeReading!: ProbeReading;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
  
  async mounted() {
    // nothing yet
    tippy('[data-tippy-content]');
  }

}

